import React from 'react';
import { Link } from 'react-router-dom';

const SingleCourse = ({ course }) => {
  return (
    <div class='media service-card col-lg-6'>
      <div class='media-body'>
        <img
          src={course['image']}
          alt='course-image'
          class='blog-post-thumbnail img-fluid'
          style={{ marginBottom: '20px' }}
        />
        <h5 class='service-title'>{course['title']}</h5>
        <p class='service-description' style={{'textAlign': 'justify'}}>{course['desc']}</p>
        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <Link
            to={`/courses/${course['link']}`}
            // target='_blank'
            className='btn btn-primary'
            style={{
              background: 'rebeccapurple',
              borderColor: 'rebeccapurple',
              paddingLeft: '20px',
              paddingRight: '20px',
              color: 'white',
            }}
          >
            View More
          </Link>
        </div>
      </div>
    </div>
  );
};

export default function Courses({ homeData }) {
  return (
    <section class='services-section'>
      {/* <h6 class="section-subtitle">WHAT I DO</h6> */}
      <h2 class='section-title'>Courses</h2>
      <div class='row'>
        {homeData &&
          homeData['courses'].map((course) => {
            return <SingleCourse course={course} />;
          })}
      </div>
    </section>
  );
}
